module.exports = __webpack_public_path__ + "img/google-play-badge.a49d2cce.svg";